// 🔐 USERS (NO DUPLICATE)
export const saveUser = (user) => {
  let users = JSON.parse(localStorage.getItem("users")) || [];

  const exists = users.find(u => u.name === user.name);

  if (exists) {
    alert("⚠️ User already exists");
    return;
  }

  users.push(user);
  localStorage.setItem("users", JSON.stringify(users));
};

export const getUsers = () => {
  return JSON.parse(localStorage.getItem("users")) || [];
};

const nowtime = new Date();
const formatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
 
  hour12: false
});

// 📅 MARK ATTENDANCE (1 PER DAY - FIXED TIMEZONE)
export const markAttendance = (name) => {
  let attendance = JSON.parse(localStorage.getItem("attendance")) || [];
  const nowtime = new Date(); // ✅ moved here

  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD (safe)

  const exists = attendance.find(
    (item) => item.name === name && item.date === today
  );

  if (exists) {
    alert("⚠️ Already marked today");
    return;
  }

  attendance.push({
    name,
    date: today,
    status: "present",
 time:formatter.format(nowtime)
  });

  localStorage.setItem("attendance", JSON.stringify(attendance));
};

// ✏️ UPDATE ATTENDANCE
export const updateAttendance = (name, date, updatedData) => {
  let attendance = JSON.parse(localStorage.getItem("attendance")) || [];

  attendance = attendance.map((item) => {
    if (item.name === name && item.date === date) {
      return {
        ...item,
        ...updatedData, // status / time update
      };
    }
    return item;
  });

  localStorage.setItem("attendance", JSON.stringify(attendance));
};

export const getAttendance = () => {
  return JSON.parse(localStorage.getItem("attendance")) || [];
};


